// extracted by mini-css-extract-plugin
module.exports = {"otherProductCell":"OtherProductCell_otherProductCell__O9GYt"};